import { Pagination } from '@/components/shared/Pagination';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Input,
  Button,
  SlidersHorizontal,
  COLUNAS,
  useTabItens,
} from '../GestaoDocumentosProvider';

interface Props {
  chaveAcesso: string;
  codigoModelo: string;
  cnpjContribuinte: string;
  dataInicio: string;
  dataFim: string;
  tipo: 'entradas' | 'saidas';
}

export function TabItens(props: Props) {
  const {
    pagina,
    setPagina,
    itensPorPagina,
    filtroCFOP,
    setFiltroCFOP,
    filtroClassTrib,
    setFiltroClassTrib,
    toggleCol,
    colsAtivas,
    colsVisiveis,
    isLoading,
    itens,
    totalItens,
    totalPaginas,
    handleFiltroChange,
    handleItensPorPaginaChange,
  } = useTabItens(props);

  return (
    <div className="space-y-3">
      {/* Filtros + configuração de colunas */}
      <div className="flex items-center gap-2 justify-end flex-wrap shrink-0">
        <Input
          placeholder="Filtrar CFOP"
          value={filtroCFOP}
          onChange={e => {
            setFiltroCFOP(e.target.value);
            handleFiltroChange();
          }}
          className="h-8 w-32 text-sm"
        />
        <Input
          placeholder="Filtrar Class. Trib."
          value={filtroClassTrib}
          onChange={e => {
            setFiltroClassTrib(e.target.value);
            handleFiltroChange();
          }}
          className="h-8 w-40 text-sm"
        />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" className="h-8 gap-1.5">
              <SlidersHorizontal className="h-3.5 w-3.5" />
              Colunas
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48 max-h-80 overflow-y-auto">
            <DropdownMenuLabel>Colunas visíveis</DropdownMenuLabel>
            <DropdownMenuSeparator />
            {COLUNAS.map(col => (
              <DropdownMenuCheckboxItem
                key={col.key as string}
                checked={!!colsVisiveis[col.key as string]}
                onCheckedChange={() => toggleCol(col.key as string)}
              >
                {col.label}
              </DropdownMenuCheckboxItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      {/* Tabela */}
      <div className="overflow-auto rounded-md border">
        <Table>
          <TableHeader className="bg-[#f7f7f7]">
            <TableRow>
              {colsAtivas.map(col => (
                <TableHead key={col.key as string} className={col.className}>
                  {col.label}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {isLoading ? (
              Array.from({ length: itensPorPagina }).map((_, i) => (
                <TableRow key={i}>
                  {colsAtivas.map(col => (
                    <TableCell key={col.key as string}>
                      <div className="h-3.5 rounded bg-muted animate-pulse w-3/4" />
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : itens.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={colsAtivas.length}
                  className="py-10 text-center text-muted-foreground text-sm"
                >
                  Nenhum item encontrado.
                </TableCell>
              </TableRow>
            ) : (
              itens.map((item, idx) => (
                <TableRow key={`${item.ChaveAcessoDOC}-${item.Sequencial ?? idx}`}>
                  {colsAtivas.map(col => (
                    <TableCell key={col.key as string} className={`text-xs ${col.className ?? ''}`}>
                      {col.render(item)}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>

      {/* Rodapé: total + paginação */}
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <span className="shrink-0">{totalItens.toLocaleString('pt-BR')} iten(s)</span>
        <div className="flex-1">
          <Pagination
            currentPage={pagina}
            totalPages={totalPaginas}
            onPageChange={setPagina}
            itensPorPagina={itensPorPagina}
            onItensPorPaginaChange={handleItensPorPaginaChange}
          />
        </div>
      </div>
    </div>
  );
}
